import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { SchemeMandaysKindsQuery as SchemeMandaysKindsQueryType } from "./__generated__/SchemeMandaysKindsQuery";

const SchemeMandaysKindsQuery = loader("./SchemeMandaysKindsQuery.gql");

type SchemeMandaysKindsQueryProviderType = (props: {
  children: (data: SchemeMandaysKindsQueryType) => ReactNode;
}) => ReactElement;

export const SchemeMandaysKindsQueryProvider: SchemeMandaysKindsQueryProviderType = (props) => {
  const { children } = props;

  const { error, loading, data } = useQuery<SchemeMandaysKindsQueryType>(SchemeMandaysKindsQuery, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
